<dx-validation-group #resetPasswordValidationGroup>
  <dx-responsive-box *ngIf="!isPasswordReset">
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>

    <dxi-col></dxi-col>
    <dxi-col></dxi-col>

    <!-- Error Message -->
    <dxi-item *ngIf="showErrorMessage">
      <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
      <div class="error-message-container">
        <p class="error-message">{{ errorMessage }}</p>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            placeholder="Username"
            [(value)]="resetPasswordParameterDto.username"
            (onEnterKey)="btnResetPasswordClick()"
            class="text-input cc-text-required"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Username is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="2" [col]="0" [colspan]="2"></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            ccPreventCopyPaste
            placeholder="Password"
            class="text-input cc-text-required"
            [(value)]="resetPasswordParameterDto.newPassword"
            [(mode)]="passwordMode"
            [inputAttr]="{ autocomplete: 'new-password' }"
            [maxLength]="30"
            (onKeyUp)="runPasswordValidation($event)"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="password"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="password"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Password is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="3" [col]="0" [colspan]="2"></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            ccPreventCopyPaste
            placeholder="Confirm Password"
            ngClass="text-input cc-text-required"
            [(mode)]="passwordMode"
            [inputAttr]="{ autocomplete: 'new-password' }"
            [maxLength]="30"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="cpassword"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="cpassword"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Confirm Password is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="passwordComparison"
                comparisonType="==="
                message="Password and Confirm Password do not match"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="4" [col]="0" [colspan]="2"></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <ul class="password-rules">
            <li *ngFor="let rule of passwordRules">
              <i
                [ngClass]="[
                  iconCircleCheck,
                  rule.isValid ? 'cc-icon-green' : 'cc-icon-mintgreen'
                ]"
              ></i>
              <span [ngClass]="{ 'cc-text-required': !rule.isValid }">
                {{ rule.label }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="5" [col]="0" [colspan]="2"></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-progress-bar
            #passStrengthSuccess
            [min]="0"
            [max]="5"
            [statusFormat]="getPasswordStrengthText"
          ></dx-progress-bar>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="6" [col]="0" [colspan]="2"></dxi-location>
      <div
        *dxTemplate
        class="user-auth-container-input-wrapper align-items-center"
      >
        <re-captcha
          #reCaptcha
          [siteKey]="recaptchaSiteKey"
          errorMode="handled"
          (resolved)="onRecaptchaResolved($event)"
          (errored)="onRecaptchaErrored()"
        ></re-captcha>
        <p *ngIf="recaptchaErrorMessage" class="recaptcha-error-message">
          {{ recaptchaErrorMessage }}
        </p>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location [row]="7" [col]="0" [colspan]="2"></dxi-location>
      <div *dxTemplate>
        <div class="reset-password-toolbar">
          <cira-button variant="outlined" (clicked)="btnBackToLogin()">
            Back to Login
          </cira-button>
          <cira-button
            variant="tile"
            [disabled]="!recaptchaToken?.length"
            (clicked)="btnResetPasswordClick()"
          >
            Submit
          </cira-button>
        </div>
      </div>
    </dxi-item>
  </dx-responsive-box>

  <!-- Success Page -->
  <div class="success-wrapper" *ngIf="isPasswordReset">
    <div class="success-icon-container">
      <i class="fa-solid fa-circle-check success-icon"></i>
    </div>
    <div class="success-message-container">
      <p class="success-message-title">
        Your request has been successfully submitted!
      </p>
      <p class="success-message-subtitle">
        Please check your email for the reset password link.
      </p>
    </div>
    <div class="signin-link-container">
      <span>Already have an account?</span>
      <a
        href="javascript:void(0)"
        (click)="btnBackToLogin()"
        class="sign-in-link"
      >
        Sign in
      </a>
    </div>
  </div>
</dx-validation-group>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#loginContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
